import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
    modal: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: "1691px",
        // minHeight: "1418px",
        minHeight:"auto",
        backgroundColor: '#FFFFFF',
        borderRadius: "12px 12px 0px 0px ",
        overflow: "auto",
    },
    modalHeader: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "20px",
        width: "100%",
        height: "70px",
        background: "#F4F6F8",
        borderRadius: "12px 12px 0px 0px",
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "22px",
        lineHeight: "28px",
        letterSpacing: "-0.001em",
        color: "#091E42"
    },
    configButton: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: "10px 20px",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "22px",
        textAlign: "center",
        color: "#FFFFFF",
        border: "none",
        borderRadius: "6px",
        marginTop: "29px",
        background: "linear-gradient(90deg, #824ED2 -0.14%, #B07DFF 99.93%)",
        cursor: "pointer",
        [theme.breakpoints.down('sm')]: {
            width: "100%"
        },
        [theme.breakpoints.down('xs')]: {
            width: "100%"
        },
    },
}));